import {injectable} from '@123/druid/dist/Framework/Decorators/Inject';
import type AbstractMessage from '@123/druid/dist/Framework/Messaging/AbstractMessage';
import MessageBusDruid from '@123/druid/dist/Framework/Messaging/MessageBus';
import type {IUnsubscribable} from '@123/druid/dist/Types/IUnsubscribable';

@injectable()
export default class MessageBus {
    public emit<T = undefined>(message: AbstractMessage, channel: string = 'default'): Promise<T> {
        return MessageBusDruid.emit(message, channel);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public observe<T extends AbstractMessage, Response = any>(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        messageConstructor: {new (...args: any[]): T},
        handler: (message: T) => Promise<Response> | Response,
        channel: string = 'default',
    ): IUnsubscribable {
        return MessageBusDruid.observe(messageConstructor, handler, channel);
    }
}
